import {useState} from 'react'

import {ShutdownHistoryCardBody} from './ShutdownHistoryCardBody'
import {ShutdownHistoryCardHeader} from './ShutdownHistoryCardHeader'

export const ShutdownHistoryCard = () => {
  const [textFilter, setTextFilter] = useState('')

  return (
    <div
      data-cy="refra_static_parts_shutdown_history_card"
      className="rounded-lg bg-container_background text-foreground"
    >
      <div className="p-16px sm:p-24px">
        <ShutdownHistoryCardHeader setTextFilter={setTextFilter} textFilter={textFilter} />
      </div>
      <div className="pb-16px sm:pb-24px">
        <ShutdownHistoryCardBody textFilter={textFilter} />
      </div>
    </div>
  )
}
